<template>
	<div class="navbar" id="navbar">
		<hamburger
			id="hamburger-container"
			:is-active="sidebar.opened"
			class="hamburger-container"
			@toggleClick="toggleSideBar"
		/>
		<breadcrumb v-if="false" id="breadcrumb-container" class="breadcrumb-container" />
		<div class="main_nav" @mouseleave="mouseLeave" :style="`max-width:${mainMaxNavWidth}px;`">
			<span ref="navbg" class="cur_bg" />
			<div class="navtxt" ref="navtxt" @click="setMainNavWidth">
				<span
					ref="navtxtspan"
					v-for="(item, index) in nav"
					:key="item.id"
					class="nav-hover"
					:class="{ cur: curId === index }"
					@mouseover="mouseOver"
					@click="goNav(item.id, index, $event, item.url, item)"
				>
					{{ item.name }}
				</span>
			</div>
		</div>
		<div v-if="scrollToShow" style="float: left">
			<i class="el-icon-caret-left caret-icon" @click="navtxtScrollTo(0)"></i>
			<i class="el-icon-caret-right caret-icon" @click="navtxtScrollTo(1000)"></i>
		</div>
		<div
			ref="rightMenu"
			class="right-menu"
			style="display: flex; justify-content: center; justify-items: center; align-items: center"
		>
			<template v-if="device !== 'mobile'">
				<!-- <search id="header-search" class="right-menu-item" /> -->

				<!-- <error-log class="errLog-container right-menu-item hover-effect" /> -->

				<!-- <screenfull id="screenfull" class="right-menu-item hover-effect" /> -->

				<el-tooltip v-if="false" effect="dark" placement="bottom">
					<size-select id="size-select" class="right-menu-item hover-effect" />
				</el-tooltip>
			</template>
			<el-switch
				style="margin-right: 20px"
				v-model="user_selection"
				@change="handleUserSelection"
				:inactive-text="inactiveText"
				active-value="1"
				inactive-value="2"
			></el-switch>
			<el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
				<div class="avatar-wrapper">
					<!-- <img :src="avatar+'?imageView2/1/w/80/h/80'" class="user-avatar"> -->
					{{ info.name }}
					<i class="el-icon-caret-bottom" />
				</div>
				<el-dropdown-menu slot="dropdown">
					<router-link to="/">
						<el-dropdown-item>首页</el-dropdown-item>
					</router-link>
					<el-dropdown-item divided>
						<span class="logout-btn" @click="logout">退出</span>
					</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>
			<div class="role">
				<span v-if="role.length">
					<svg-icon icon-class="role" />
					{{ role[0] }}
				</span>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import ErrorLog from '@/components/ErrorLog'
import Screenfull from '@/components/Screenfull'
import SizeSelect from '@/components/SizeSelect'
import Search from '@/components/HeaderSearch'

const LAST_MAIN_NAV_ID_KEY = 'last_main_nav_id'

export default {
	components: {
		Breadcrumb,
		Hamburger,
		ErrorLog,
		Screenfull,
		SizeSelect,
		Search
	},
	data() {
		return {
			curId: 0,
			curLeft: 0,
			user_selection: '2',
			inactiveText: '嵌套模式',
			mainMaxNavWidth: 1100,
			scrollToShow: false,
			rightMenuWidth: 300,
			hasRestoredMainNav: false
		}
	},
	computed: {
		...mapGetters(['nav', 'sidebar', 'avatar', 'name', 'role', 'device', 'info'])
	},
	watch: {
		user_selection(val) {
			if (val == 1) {
				this.inactiveText = '新窗口模式'
			} else {
				this.inactiveText = '嵌套模式'
			}
		},
		sidebar() {
			this.setMainNavWidth()
		},
		'$store.state.user.menu': {
			handler() {
				this.restoreMainNavSelection()
			},
			deep: false
		},
		nav() {
			this.restoreMainNavSelection()
		}
	},
	mounted() {
		if (localStorage.getItem('user_selection')) {
			this.user_selection = localStorage.getItem('user_selection')
		}
		this.restoreMainNavSelection()
		this.getListening()
		if (this.$refs.rightMenu) {
			this.rightMenuWidth = this.$refs.rightMenu.offsetWidth
		}
		this.setMainNavWidth()
		window.onresize = () => {
			return (() => {
				this.setMainNavWidth()
			})()
		}
		this.$root.$on('update-nav-highlight', id => {
			const index = this.nav.findIndex(item => item.id === id)
			if (index !== -1) {
				this.curId = index
				localStorage.setItem(LAST_MAIN_NAV_ID_KEY, String(id))
				this.$nextTick(() => {
					if (this.$refs.navtxt && this.$refs.navtxt.children[index]) {
						const target = this.$refs.navtxt.children[index]
						this.curLeft = target.offsetLeft
						this.$refs.navbg.style.width = target.offsetWidth + 'px'
						this.$refs.navbg.style.transform = `translateX(${
							target.offsetLeft - this.$refs.navtxt.scrollLeft
						}px)`
					}
				})
			}
		})
	},
	beforeDestroy() {
		this.$root.$off('update-nav-highlight')
	},
	methods: {
		syncNavHighlightByIndex(index) {
			this.$nextTick(() => {
				if (this.$refs.navtxt && this.$refs.navtxt.children[index]) {
					const target = this.$refs.navtxt.children[index]
					this.curLeft = target.offsetLeft
					this.$refs.navbg.style.width = target.offsetWidth + 'px'
					this.$refs.navbg.style.transform = `translateX(${target.offsetLeft - this.$refs.navtxt.scrollLeft}px)`
				}
			})
		},
		restoreMainNavSelection() {
			if (this.hasRestoredMainNav) return
			const menu = this.$store.state.user.menu || []
			const nav = this.nav || []
			if (!menu.length || !nav.length) return
			const savedMainNavId = localStorage.getItem(LAST_MAIN_NAV_ID_KEY)
			const savedNavIndex = nav.findIndex(item => String(item.id) === String(savedMainNavId))
			if (savedNavIndex !== -1) {
				this.goNav(nav[savedNavIndex].id, savedNavIndex)
				this.syncNavHighlightByIndex(savedNavIndex)
			} else {
				this.goNav(nav[0].id, 0)
				this.syncNavHighlightByIndex(0)
			}
			this.hasRestoredMainNav = true
		},
		toggleSideBar() {
			this.$store.dispatch('app/toggleSideBar')
			setTimeout(() => {
				this.setMainNavWidth()
			}, 300)
		},
		mouseOver(event) {
			let scrollLeft = this.$refs.navtxt.scrollLeft
			this.$refs.navbg.style.width = event.target.offsetWidth + 'px'
			this.$refs.navbg.style.transform = `translateX(${event.target.offsetLeft - scrollLeft}px)`
		},
		mouseLeave(event) {
			let scrollLeft = this.$refs.navtxt.scrollLeft
			this.$refs.navbg.style.transform = `translateX(${this.curLeft - scrollLeft}px)`
			this.$refs.navbg.style.width = this.$refs.navtxt.children[this.curId].offsetWidth + 'px'
		},
		goNav(id, index, e, url) {
			setTimeout(() => {
				if (e) {
					this.curLeft = e.target.offsetLeft
					this.mouseOver(e)
				}
			}, 0)
			this.curId = index
			localStorage.setItem(LAST_MAIN_NAV_ID_KEY, String(id))
			const menu = this.$store.state.user.menu
			const curMenu = []
			for (const i in menu) {
				if (menu[i].meta.id === id) curMenu.push(menu[i])
			}
			this.$store.dispatch('permission/generateRoutes', { menu: curMenu })
		},
		async logout() {
			await this.$store.dispatch('user/logout')
			if (this.$route.fullPath !== '/401')
				this.$router.push(`/login?redirect=${this.$route.fullPath}`)
			else this.$router.push(`/login`)
			// location.reload()
		},
		handleUserSelection(val) {
			localStorage.setItem('user_selection', val)
		},
		getListening() {
			if (document.hidden !== undefined) {
				document.addEventListener('visibilitychange', () => {
					if (localStorage.getItem('user_selection')) {
						this.user_selection = localStorage.getItem('user_selection')
					}
				})
			}
		},
		setMainNavWidth() {
			if (!document.getElementById('navbar')) {
				return
			}
			let navbarWidth = document.getElementById('navbar').offsetWidth
			let widthSum = 0
			this.$refs.navtxtspan.forEach(element => {
				widthSum += element.offsetWidth
			})
			let mainMaxNavWidth = navbarWidth - 36 - 20 - this.rightMenuWidth
			this.mainMaxNavWidth = mainMaxNavWidth
			this.scrollToShow = false
			if (this.mainMaxNavWidth < widthSum) {
				this.scrollToShow = true
				this.mainMaxNavWidth -= 36
			}
		},
		navtxtScrollTo(xNum) {
			this.$refs.navtxt.scrollLeft = xNum
			this.mouseLeave()
		}
	}
}
</script>

<style lang="scss" scoped>
.main_nav {
	position: relative;
	float: left;
	height: 55px;
	line-height: 55px;
	color: #f3f3f3;
	font-size: 16px;
	span {
		display: inline-block;
		width: auto;
		padding: 0 10px;
		text-align: center;
		cursor: pointer;
		svg {
			font-size: 14px;
			margin-right: 5px;
		}
	}
	.cur_bg {
		width: 88px;
		height: 3px;
		position: absolute;
		bottom: 0;
		z-index: 1;
		border-bottom: 4px solid #1890ff;
		transform: translate(0);
		transition: all 500ms ease;
	}
	.cur {
		font-size: 17px;
		color: #fff;
	}
}
.nav-hover {
	font-family: 'Microsoft YaHei';
}
.nav-hover:hover {
	background-color: #263445;
}
.navbar {
	height: 55px;
	line-height: 55px;
	overflow: hidden;
	position: relative;
	background: #304156;
	box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
	.role {
		display: inline;
		font-size: 18x;
		vertical-align: text-bottom;
		margin-right: 30px;
		color: #f1f1f1;
		svg {
			font-size: 24px;
			vertical-align: middle;
			color: #f1f1f1;
		}
	}
	.hamburger-container {
		height: 100%;
		float: left;
		cursor: pointer;
	}

	.breadcrumb-container {
		float: left;
	}

	.errLog-container {
		display: inline-block;
		vertical-align: top;
	}

	.right-menu {
		float: right;
		height: 100%;

		&:focus {
			outline: none;
		}

		.right-menu-item {
			display: inline-block;
			padding: 0 8px;
			height: 100%;
			font-size: 18px;
			color: #f1f1f1;
			vertical-align: text-bottom;

			&.hover-effect {
				cursor: pointer;
				transition: background 0.3s;

				&:hover {
					background: rgba(0, 0, 0, 0.025);
				}
			}
		}

		.avatar-container {
			margin-right: 30px;

			.avatar-wrapper {
				position: relative;
				.user-avatar {
					cursor: pointer;
					width: 40px;
					height: 40px;
					border-radius: 10px;
				}

				.el-icon-caret-bottom {
					cursor: pointer;
					position: absolute;
					right: -20px;
					top: 20px;
					font-size: 12px;
				}
			}
		}
	}
}
.navtxt {
	font-weight: bolder;
	white-space: nowrap;
	overflow: auto;
}
::v-deep .el-switch__label {
	color: #f3f3f3;
	.is-active {
		color: #f3f3f3;
	}
}
.caret-icon {
	color: #f3f3f3;
	font-size: 18px;
	cursor: pointer;
	&:hover {
		color: #5cb6ff;
	}
}
.logout-btn {
	display: block;
	margin: 0 -15px;
	text-align: center;
}
</style>
